export default {
  toolbar: {
    minHeight: '2.79rem',
    borderBottom: '1px solid black'
  },
  text: (isAtMobile: boolean) => ({
    fontSize: isAtMobile ? '0.6rem' : '0.8rem'
  })
}
